import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Icon from '@cobliteam/ui/icons';

interface DataTableRefreshProps {
  onRefresh?: () => void;
  isFetching?: boolean;
}

const DataTableRefresh = ({ onRefresh, isFetching }: DataTableRefreshProps) => {
  const { t } = useTranslation('ui-business');

  if (!onRefresh) return null;

  const handleRefresh = () => {
    Analytics.track('DataTable Refresh Button Clicked');
    onRefresh();
  };

  return (
    <Tooltip content={t('data_table.refresh_data')} position='top'>
      <Button
        data-testid='datatable-refresh-button'
        loading={isFetching}
        disabled={isFetching}
        color='default'
        variant='outlined'
        size='sm'
        icon={<Icon name='rotate-cw' />}
        onClick={handleRefresh}
        className='shrink-0'
      />
    </Tooltip>
  );
};

export default DataTableRefresh;
